import ImageRequest from 'Assets/images/pages/web-chat/bot-request.svg';
import ImageLeftQuote from 'Assets/images/pages/web-chat/left-quote.svg';
import { shape } from 'prop-types';
import React, { useState } from 'react';
import { Image, Segment } from 'semantic-ui-react';

import style from '../MessageBot.less';

import ModalBotRequest from './ModalBotRequest';

const findReasonFromMessage = contents => {
  const content = contents.find(item => item.key === 'new_request_reason');
  return (content && content.body) || '';
};

const MessageCompletedRequest = props => {
  const [isOpenRequest, setOpenRequest] = useState(false);
  const { message } = props;
  const {
    message: {
      attachment: { content },
    },
  } = message;
  const toggleRequest = () => setOpenRequest(prev => !prev);
  return (
    <div className="bot-message">
      {isOpenRequest && <ModalBotRequest message={message} close={toggleRequest} />}
      <Segment.Group className="content" onClick={toggleRequest}>
        <div className={style.content}>
          <div className={style.left}>
            <div className={style.title}>Consult Request</div>
            {/* <div className={style.meta}>{formatDate(sentAt, 'MMM DD, YYYY HH:mm')}</div> */}
          </div>
          <div className={style.icon}>
            <Image src={ImageRequest} />
          </div>
        </div>
        <div>
          <div className={style.bodyAction}>
            <Image src={ImageLeftQuote} />
            <div className="message-quote">{findReasonFromMessage(content) || 'N/A'}</div>
          </div>
        </div>
      </Segment.Group>
    </div>
  );
};

MessageCompletedRequest.propTypes = {
  message: shape({}).isRequired,
};

export default MessageCompletedRequest;
